import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageAdd"><Path d="M3 21V3H8V10H16V3H21V12H16V15H13V21H3Z" fill="currentColor"/><Path d="M14.5 3H9.5V8.5H14.5V3Z" fill="currentColor"/><Path d="M22 16.5H19V13.5H17.5V16.5H14.5V18H17.5V21H19V18H22V16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageAdd;
